import React, { memo, useMemo } from 'react';
import { HeaderWrapper, HeaderRow } from '@creditflowresearch/uilib/Table/DataTable';
import { getRankYearHeaderColumns } from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/helpers';
import { IColumnScorecard } from '@/creditflowresearch/application/League/interfaces';
import { IPeriod } from '@/creditflowresearch/domain/vo/League/IStandings';

import standingStyles from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/standingTable.module.scss';

interface IProps {
  countColumn: number,
  periods: IPeriod[],
}

const getYearCell = ({ title }: IColumnScorecard) => (
  <span className={ standingStyles.wrapperRankHeaderCell }>
    { title }
  </span>
);

const Header = ({
  countColumn,
  periods,
}: IProps) => {
  const headerColumns = useMemo(
    () => getRankYearHeaderColumns(periods, getYearCell),
    [periods, getYearCell],
  );

  const colSpan = useMemo(() => periods.length + 2, [periods]);
  const legendString = useMemo(() => `market rank${ countColumn > 1 ? ' by deal count' : '' }`, [countColumn]);

  return (
    <HeaderWrapper>
      <HeaderRow columns={ headerColumns } />
      <tr>
        <th
          colSpan={ colSpan }
          className={ standingStyles.rankLegendHeaderColumn }
        >
          { legendString }
        </th>
      </tr>
    </HeaderWrapper>
  );
};

export default memo(Header);
